import React from 'react';
import PropTypes from 'prop-types';

import { StyledDiv, StyledLabel, StyledSelect } from './VirtualGiftCardProductVariantSelectorStyles';

var _ref = React.createElement(
  'option',
  { disabled: true, selected: true },
  'Choose Your Amount'
);

var VirtualGiftCardProductVariantSelector = function VirtualGiftCardProductVariantSelector(props) {
  var selectedOption = props.selectedOptions[props.option.name]; // can be upper/lower case
  return React.createElement(
    StyledDiv,
    null,
    React.createElement(
      StyledSelect,
      {
        onChange: props.handleOptionChange,
        name: props.option.name,
        key: props.option.name,
        value: selectedOption[0].value
      },
      _ref,
      props.option.values.map(function (value) {
        return React.createElement(
          'option',
          { key: props.option.name + '-' + value, value: value },
          '' + value
        );
      })
    )
  );
};

VirtualGiftCardProductVariantSelector.propTypes = {
  option: PropTypes.object.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  variants: PropTypes.array.isRequired,
  productId: PropTypes.string.isRequired,
  parent: PropTypes.string,
  showLabel: PropTypes.bool,
  handleOptionChange: PropTypes.func.isRequired
};

export default React.memo(VirtualGiftCardProductVariantSelector);